<template>
  <div class='container'>

<!--    <iframe src='https://resume.misec.top/resume-22.html' width='100%' height='1000px'></iframe>-->
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.bg {
  width: 100%;
  margin-bottom: 40px;
}

.back-home {
  font-weight: 700;
  font-size: 18px;
}

.back-home:hover {
  border: none;
}
</style>